// extracted by mini-css-extract-plugin
export default {"footertext":"Footer_footertext__Zevi3","githubname":"Footer_githubname__4DTHT"};